import DefinitiveBackup from "./DefinitiveBackup";
import MissionsPage from "pages/missions/Missions";
import TemporaryBackup from "./TemporaryBackup";
import { CreateMission } from "./CreateMission";
import { Route } from "react-router-dom";

const routes = {
  key: "MISSIONS",
  routes: ({ userScope }) => [
    <Route
      key={"manage-missions"}
      path={`${userScope}/missions`}
      element={<MissionsPage />}
    />,
    <Route path={`${userScope}/missions`} key={"display-mission"}>
      <Route
        path="creation"
        element={<CreateMission />}
        key={"create-mission"}
      />
      <Route
        path="creation"
        key={"mission-creation"}
        element={<CreateMission />}
      />
      <Route
        path=":slug/temporary-backup"
        key={"mission-temporary-backup"}
        element={<TemporaryBackup />}
      />
      <Route
        path=":slug/definitive-backup"
        key={"mission-definitive-backup"}
        element={<DefinitiveBackup />}
      />
      <Route path=":slug" key={"mission-display"} element={<MissionsPage />} />
    </Route>,
  ],
};
export default routes;
